import { routeConfig } from "@zickko/client";

export namespace emailPortalRoutes {
  export const home = routeConfig<{}, { emailId?: string }>("/");
  export const archive = routeConfig<{}, { emailId?: string }>("/archive");
  export const trash = routeConfig<{}, { emailId?: string }>("/trash");
  export const outbox = routeConfig<{}, { emailId?: string }>("/outbox");
  export const drafts = routeConfig<{}, { emailId?: string }>("/drafts");
  export const compose = routeConfig<{}, {}>("/compose");
}
